// extracted by mini-css-extract-plugin
export default {"group":"_04_FileTool_group__Qhf3C","button":"_04_FileTool_button__Zqz1+","disabled":"_04_FileTool_disabled__mBozq","text":"_04_FileTool_text__9RP-d"};